<div *ngIf="fields && fields.length > 0" class="custom-fields-section">

    <div class="section-header d-flex align-items-center mb-3">
        <fa-icon [icon]="['fas', 'list']" class="mr-2 text-primary"></fa-icon>
        <h6 class="text-uppercase text-muted font-weight-bold m-0 mr-2">{{ 'portal.shipment.page.instructions.additional-information' | translate }}</h6>
        <span class="badge badge-pill badge-light border">{{ fields.length }}</span>
    </div>

    <div class="custom-fields-grid" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let field of fields">
            <div *ngIf="!field.hidden || showHiddenFields"
                 class="custom-field-card p-3 border rounded shadow-sm position-relative"
                 [ngClass]="[getFieldClass(field), field.hidden ? 'is-hidden opacity-50' : '']"
                 cdkDrag>

                <div class="drag-handle text-muted" cdkDragHandle [title]="'portal.shipment.page.instructions.drag-to-sort' | translate">
                    <fa-icon [icon]="['far', 'bars']"></fa-icon>
                </div>

                <div class="field-actions position-absolute" style="top: 0.5rem; right: 0.5rem;">
                    <button class="btn btn-link btn-sm p-0 text-muted"
                            (click)="toggleFieldVisibility(field, $event)"
                            [pTooltip]="(field.hidden ? 'portal.shipment.page.instructions.show-field' : 'portal.shipment.page.instructions.hide-field') | translate"
                            tooltipPosition="top">
                        <fa-icon [icon]="['far', field.hidden ? 'eye' : 'eye-slash']"></fa-icon>
                    </button>
                </div>

                <div class="field-label mb-1 pr-4 pl-3 text-truncate-3-lines" [pTooltip]="field.display_name" tooltipPosition="top">{{ field.display_name }}</div>

                <div class="field-value pl-3 text-truncate-3-lines"
                     *ngIf="dateFormat$ | async; let date_format"
                     [pTooltip]="field | customFieldValue: date_format | stringOrUndefined"
                     tooltipPosition="top"
                     [innerHTML]="field | customFieldValue: date_format | lineBreaks">
                </div>

                <!-- Placeholder for drag and drop -->
                <div *cdkDragPlaceholder class="custom-field-placeholder"></div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="hasHiddenFields" class="text-right mt-2">
        <button class="btn btn-link btn-sm text-muted" (click)="toggleShowHidden()">
            <span>{{ (showHiddenFields ? 'portal.shipment.page.instructions.hide-hidden-fields' : 'portal.shipment.page.instructions.show-hidden-fields') | translate }}</span><span class="badge badge-pill badge-secondary ml-1">{{ hiddenFieldsCount }}</span>
        </button>
    </div>

</div>
